// import { faChevronDown as lightChevronDown } from "@jewlr/pro-light-svg-icons/faChevronDown"
// import { faChevronUp as lightChevronUp } from "@jewlr/pro-light-svg-icons/faChevronUp"
// import { Expand } from "@jewlr/storybook/animate"
// import { Box, Button, FontAwesomeIcon, Typography } from "@jewlr/storybook/core"
// import { useState } from "react"
import { FocusScope } from "@react-aria/focus"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { updateChoice } from "areas/product/store/actions"
import { to_currency } from "helpers/number"
import { imageLookup } from "helpers/product/image-lookup"
import { useNavigation } from "helpers/use-navigation"

import {
  ChoiceOption,
  GradientContainer,
  OptionsSlider,
  OptionImage,
  OptionTitle,
  OptionPrice,
} from "./components"

const ChoiceOptions = ({ asv, handleClick, selected }) => {
  const keyboardProps = useNavigation({ direction: "horizontal" })
  return (
    <ChoiceOption
      aria-checked={selected}
      data-is-option="true"
      data-is-selected={selected}
      onClick={handleClick}
      role="radio"
      selected={selected}
      tabIndex={selected ? 0 : -1}
      {...keyboardProps}
    >
      <OptionImage
        alt={asv.title}
        sizes="40px"
        src={imageLookup("as", asv.imageKey).x2}
        srcSet={
          imageLookup("as", asv.imageKey).x1 +
          " 1x," +
          imageLookup("as", asv.imageKey).x2 +
          " 2x"
        }
        title={asv.title}
      />

      <OptionTitle>{asv.title}</OptionTitle>
      <OptionPrice>{to_currency(asv.price)}</OptionPrice>
    </ChoiceOption>
  )
}

ChoiceOptions.propTypes = {
  asv: PropTypes.object,
  handleClick: PropTypes.func,
  selected: PropTypes.bool,
}

const InternalAccentOptions = ({ data, selectedValue, setChoice }) => {
  // const [showDetail, setshowDetail] = useState(false)
  // const [accentDetail, setAccentDetail] = useState(data.options[0])

  return (
    <GradientContainer>
      <FocusScope restoreFocus>
        <OptionsSlider
          aria-label={`${data.heading.title} Options`}
          data-slider="true"
          justifyContent={{ tablet: "center" }}
          role="radiogroup"
        >
          {data.options.map((asv) => (
            <ChoiceOptions
              asv={asv}
              data={data}
              handleClick={(e) => {
                setChoice(data.pref, asv, e)
                // setAccentDetail(asv)
              }}
              key={`sliderAccentOption-${asv.value}`}
              selected={selectedValue === asv.value}
            />
          ))}
        </OptionsSlider>
      </FocusScope>
      {/* Notes for Dev: */}
      {/* Comment out Accent Stone Expand temporarily as we dont' have dynamic details for each stone */}
      {/* <Box mb={3}>
        <Button
          color="primary"
          fontSize="11px"
          fontWeight="500"
          letterSpacing="0.5px"
          lineHeight="13px"
          mb={1}
          onClick={() => setshowDetail(!showDetail)}
          variant="text"
        >
          About {accentDetail.title}{" "}
          <FontAwesomeIcon
            color="primary"
            fontSize="8px"
            icon={showDetail ? lightChevronUp : lightChevronDown}
            ml="5px"
          />
        </Button>
        <Expand show={showDetail}>
          <Typography
            color="grey.35"
            fontSize="12px"
            fontWeight="500"
            letterSpacing="0.5px"
            lineHeight="14px"
          >
            Cubic Zirconia is a semi-precious stone that are used as diamond
            simulants.What distinguishes it from the others is that its cut
            gives it a shiny semblance close to diamond when it is subject to
            light.
          </Typography>
        </Expand>
      </Box> */}
    </GradientContainer>
  )
}

const getSelectedValue = (state, ownprops) => {
  if (typeof state.choices[ownprops.pref] === "undefined") {
    return ""
  } else {
    return state.choices[ownprops.pref].value
  }
}

const getData = (state, ownProps) => {
  return state.wizard.data[ownProps.pref]
}
const mapStateToProps = (state, ownProps) => {
  return {
    data: getData(state, ownProps),
    selectedValue: getSelectedValue(state, ownProps),
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setChoice: (pref, data) => {
      dispatch(updateChoice(pref, data, true))
      try {
        if (typeof ownProps.callback !== "undefined" && ownProps.callback) {
          ownProps.callback()
        }
      } catch (error) {
        console.log("CALLBACK ERROR:", error)
      }
    },
  }
}

InternalAccentOptions.propTypes = {
  data: PropTypes.object,
  selectedValue: PropTypes.string,
  setChoice: PropTypes.func,
}

const AccentOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalAccentOptions)

export default AccentOptions
